import React, { useState } from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import axios from 'axios';
import Image from './newsletter.jpg'; // Ensure this matches the actual file name or path

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const SEND_FAILED_MESSAGE = "We couldn't subscribe you right now. Please check your connection and try again.";

const NewsletterSubscription = () => {
  const [email, setEmail] = useState('');
  const [website, setWebsite] = useState('');
  const [isSubmit, setIsSubmit] = useState(false);
  const [status, setStatus] = useState({ type: '', text: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmit) return;

    const value = email.trim();
    if (!EMAIL_PATTERN.test(value)) {
      setStatus({ type: 'error', text: 'Please enter a valid email address.' });
      return;
    }

    setIsSubmit(true);
    setStatus({ type: '', text: '' });

    const payload = new FormData();
    payload.append('email', value);
    payload.append('website', website);

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}mycon/newsletter_subscribe`, payload);
      if (response.data?.response === 'success') {
        setEmail('');
        setStatus({ type: 'success', text: response.data.message || 'Thank you for subscribing!' });
        return;
      }
      setStatus({ type: 'error', text: response.data?.message || SEND_FAILED_MESSAGE });
    } catch (error) {
      console.error('Newsletter subscription failed', error);
      setStatus({ type: 'error', text: SEND_FAILED_MESSAGE });
    } finally {
      setIsSubmit(false);
    }
  };

  return (
    <div className="newsletter-section">
      <style>
        {`
          .newsletter-section {
            background: #f54874;
            border-radius: 20px;
            padding: 50px 30px;
            margin: 40px 0;
            color: #fff;
          }

          .newsletter-image {
            width: 50%;
            height: auto;
          }

          .newsletter-title {
            font-size: 1.6rem;
            font-weight: 600;
            color: white;
            margin-bottom: 20px;
          }

          .newsletter-form-wrapper {
            background: white;
            border-radius: 50px;
            display: flex;
            align-items: center;
            padding: 5px 10px;
            max-width: 400px;
            margin-bottom: 10px;
          }

          .newsletter-form input {
            border: none;
            outline: none;
            padding: 10px 15px;
            border-radius: 50px;
            flex: 1;
          }

          .subscribe-btn {
            background: black;
            color: white;
            border: none;
            padding: 10px 20px;
            border-radius: 50px;
            font-weight: 500;
            white-space: nowrap;
          }

          .newsletter-desc {
            font-size: 0.85rem;
            color: white;
          }

          .newsletter-hp {
            position: absolute;
            left: -10000px;
            width: 1px;
            height: 1px;
            overflow: hidden;
          }

          .newsletter-status {
            display: inline-block;
            font-size: 0.9rem;
            font-weight: 600;
            padding: 6px 12px;
            border-radius: 8px;
            margin-bottom: 10px;
            background: #fff;
          }

          .newsletter-status--success {
            color: #198754;
          }

          .newsletter-status--error {
            color: #c82333;
          }

          @media (max-width: 768px) {
            .newsletter-title {
              font-size: 1.2rem;
            }

            .newsletter-form-wrapper {
              flex-direction: column;
              align-items: stretch;
              border-radius: 20px;
            }

            .subscribe-btn {
              width: 100%;
              margin-top: 10px;
              border-radius: 20px;
            }
          }
        `}
      </style>

      <Container>
        <Row className="align-items-center">
          <Col md={5} className="text-center mb-4 mb-md-0">
            <img src={Image} alt="Subscribe" className="newsletter-image" />
          </Col>
          <Col md={7}>
            <h4 className="newsletter-title">
              Subscribe to our newsletter for the<br />latest updates and insights.
            </h4>
            <div className="newsletter-form-wrapper">
              <Form className="newsletter-form w-100 d-flex" onSubmit={handleSubmit} noValidate>
                <Form.Control
                  type="email"
                  placeholder="Enter your email"
                  aria-label="Email address"
                  autoComplete="email"
                  maxLength={150}
                  value={email}
                  onChange={(e) => { setEmail(e.target.value); setStatus({ type: '', text: '' }); }}
                  disabled={isSubmit}
                  required
                />
                <input
                  type="text"
                  name="website"
                  className="newsletter-hp"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  value={website}
                  onChange={(e) => setWebsite(e.target.value)}
                />
                <Button type="submit" className="subscribe-btn" disabled={isSubmit}>
                  {isSubmit ? 'Subscribing...' : 'Subscribe'}
                </Button>
              </Form>
            </div>
            {status.text && (
              <p className={`newsletter-status newsletter-status--${status.type}`} role={status.type === 'error' ? 'alert' : 'status'}>
                {status.text}
              </p>
            )}
            <p className="newsletter-desc">
              Stay ahead with the latest updates, insights, and events from Hindu Sanjog.
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default NewsletterSubscription;
